export default class CaseManager {
  public static readonly GET_INFO = '/case-manager/info';
}
